"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { defaultUiLabels } from "./defaultUiLabels";
import type { UiLabels, UiLabelsOverrides } from "./UiLabels.types";
import { UiLabelsContext } from "./UiLabelsProvider";
const sections = Object.keys(defaultUiLabels) as (keyof UiLabels)[];
const defined = (entries: object) => Object.fromEntries(Object.entries(entries).filter(([, value]) => value !== undefined));
export const mergeUiLabels = (overrides: UiLabelsOverrides): UiLabels => Object.fromEntries(sections.map(section => [section, {
  ...defaultUiLabels[section],
  ...defined(overrides[section] ?? {})
}])) as unknown as UiLabels;
export const useUiLabels = () => {
  const $ = _c(2);
  const t0 = useContext(UiLabelsContext);
  let t1;
  if ($[0] !== t0) {
    t1 = mergeUiLabels(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};